import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PortalLayout.module.scss';

type PortalFooterProps = {
  companyName: string;
  websiteLinkUrl?: string | null;
  careersLinkUrl?: string | null;
};

// Whitelabeled footer shared by the portal page and every portal-journey page.
const PortalFooter: FC<PortalFooterProps> = ({
  companyName,
  websiteLinkUrl,
  careersLinkUrl,
}) => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <span>
        © {companyName} · {t('candidatePortal.poweredBy')}
      </span>
      <nav className={styles.footerLinks}>
        {websiteLinkUrl && (
          <a href={websiteLinkUrl} target="_blank" rel="noreferrer noopener">
            {t('candidatePortal.companyWebsite')}
          </a>
        )}
        {careersLinkUrl && (
          <a href={careersLinkUrl} target="_blank" rel="noreferrer noopener">
            {t('candidatePortal.companyCareers')}
          </a>
        )}
      </nav>
    </footer>
  );
};

export default PortalFooter;
